import { render, staticRenderFns } from "./RegistrationLoginNameNewFormDescription.vue?vue&type=template&id=24e2f59b&scoped=true&"
import script from "./RegistrationLoginNameNewFormDescription.vue?vue&type=script&lang=js&"
export * from "./RegistrationLoginNameNewFormDescription.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLoginNameNewFormDescription.vue?vue&type=style&index=0&id=24e2f59b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2f59b",
  null
  
)

/* custom blocks */
import block0 from "@/locales/login.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cforms%5Cregistration%5CRegistrationLoginNameNewFormDescription.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports